import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { directoryService } from '../../services/directory.service';
import { useTranslation } from '../../hooks/useTranslation.jsx';

const { FiSearch, FiMapPin, FiPhone, FiGlobe, FiInfo } = FiIcons;

export default function DirectoryPage() {
  const { contentLanguage } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const data = directoryService.getMockDirectory();
    setItems(data);
    setLoading(false);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          {contentLanguage === 'el' ? 'Κατάλογος Υποστήριξης' : 'Support Directory'}
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl">
          {contentLanguage === 'el' 
            ? 'Βρείτε νοσοκομεία, ΜΚΟ και υπηρεσίες υποστήριξης κοντά σας.' 
            : 'Find hospitals, NGOs, and support services near you.'}
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {items.map((item, index) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all flex flex-col md:flex-row gap-6"
          >
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center">
                <SafeIcon icon={item.type === 'hospital' ? FiMapPin : FiInfo} className="text-2xl" />
              </div>
            </div>
            
            <div className="flex-grow">
              <div className="flex items-start justify-between mb-2">
                <h3 className="text-xl font-bold text-gray-900">
                  {item.name[contentLanguage]}
                </h3>
                {item.is_verified && (
                  <span className="px-2 py-1 bg-blue-50 text-blue-600 text-[10px] font-bold uppercase tracking-wider rounded-md border border-blue-100">
                    Verified
                  </span>
                )}
              </div>
              
              <p className="text-gray-600 mb-4">
                {item.description[contentLanguage]}
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <button className="flex items-center gap-2 text-sm text-gray-500 hover:text-blue-600 transition-colors">
                  <SafeIcon icon={FiPhone} />
                  <span>{contentLanguage === 'el' ? 'Επικοινωνία' : 'Contact'}</span>
                </button>
                <button className="flex items-center gap-2 text-sm text-gray-500 hover:text-blue-600 transition-colors">
                  <SafeIcon icon={FiGlobe} />
                  <span>{contentLanguage === 'el' ? 'Ιστότοπος' : 'Website'}</span>
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}